import { Grid, Typography } from "@mui/material";
import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
const DemoPaper = styled(Paper)(({ theme }) => ({
  alignContent: "center",
  width: 490,
  height: 120,
  padding: theme.spacing(6),
  ...theme.typography.h6,
  textAlign: "center",
}));

function ErrorBoundaryRoute() {
 
  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      mt={30}
    >
      <DemoPaper variant="elevation">
        <Typography sx={{ color: "error.main" }}>Page Not Found</Typography>
        {/* <Typography onClick={() => onClick()}> Please click here</Typography> */}
        {/* <Link to="/portal"  sx={{ color: 'info.main' }}> Please click here</Link> */}
      </DemoPaper>
    </Stack>
  );
}

export default ErrorBoundaryRoute;
